import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { useMcpApp } from 'client/utils/mcp/use-mcp-app';
import { Link } from 'site-modules/shared/components/link/link';

const EDMUNDS_SITE = 'Edmunds.com';

export const EdmundsCarmaxDisclaimer = ({
  isEdmundsLink = false,
  agreementLinkClassName = '',
  onMcpAppLinkClick = undefined,
  agreementLinkTarget = undefined,
}) => {
  const isAppExtensionPage = useSelector(state => get(state, 'pageContext.isAppExtensionPage'));
  const mcpApp = useMcpApp();
  const hostOrigin = onMcpAppLinkClick ? mcpApp?.app?.getHostContext()?.origin || '' : '';
  const extension = isAppExtensionPage ? 'app' : 'html';
  const agreementLink = `/about/visitor-agreement.${extension}`;
  const agreementLinkClasses = classnames('text-underline', agreementLinkClassName);

  return (
    <>
      {isEdmundsLink ? (
        <Link to="/" className="text-underline">
          {EDMUNDS_SITE}
        </Link>
      ) : (
        EDMUNDS_SITE
      )}
      , Inc. is a wholly owned subsidiary of CarMax, Inc. To learn more about the relationship between Edmunds and
      CarMax, see our{' '}
      {hostOrigin ? (
        // Real <a>, matching other links in this MCP tool, so onMcpAppLinkClick can open it outside the iframe
        <a
          href={`${hostOrigin}${agreementLink}`}
          className={agreementLinkClasses}
          rel="noopener noreferrer"
          target={agreementLinkTarget}
          onClick={onMcpAppLinkClick}
        >
          Visitor Agreement
        </a>
      ) : (
        <Link to={agreementLink} className={agreementLinkClasses} rel="noopener noreferrer">
          Visitor Agreement
        </Link>
      )}
      .
    </>
  );
};

EdmundsCarmaxDisclaimer.propTypes = {
  isEdmundsLink: PropTypes.bool,
  agreementLinkClassName: PropTypes.string,
  onMcpAppLinkClick: PropTypes.func,
  agreementLinkTarget: PropTypes.string,
};
